<template>
  <v-tooltip v-if="tip"
    :disabled="Boolean(disabled)"
    :left="left" 
    :right="right" 
    :top="top" 
    :bottom="bottom" 
    :color="color || 'secondary'"
    content-class="caption"
    :close-delay="tooltips.closeDelay"
    :open-on-hover="true"
    :transition="tooltips.transition">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" icon @click="clicked">
        <v-icon>{{hide ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}}</v-icon>
      </v-btn>
    </template>
    <span>{{tip}}</span>
  </v-tooltip>
  <v-btn v-else icon @click="emitClick">
    <v-icon :color="hideIconColor">{{hide ? getIcon('hide') : getIcon('show')}}</v-icon>
  </v-btn>
</template>
<script>
import { getIconColor, getIcon, settings } from '@/js/store'
export default {
  props: {
    emitClick: String,
    hide: Boolean,
    propName: String,
    tooltip: String,
    top: Boolean,
    bottom: Boolean,
    left: Boolean,
    right: Boolean,
    disabled: Boolean,
    color: String
  },

  computed: {
    tooltips () {
      return settings.tooltips
    },
    tip () {
      return this.tooltip 
        ? `${this.hide ? 'Show' : 'Hide'} ${this.tooltip}` 
        : null
    }
  },
  methods: {
    getIcon (name) {
      return getIcon(name)
    },
    getIconColor (name) {
      return getIconColor(name)
    },
    clicked () {
      this.$emit(this.emitClick || 'hide', {
        propName: this.propName || 'hideDetail',
        hide: !this.hide
      })
    }
  }
}
</script>